/**
 * US State Boundaries data layer - checkbox + description.
 * Uses useDataLayer; state boundaries have async load in MapController.
 * Syncs from layout so layer shows when provided in initialLayers even before tab is opened.
 */
import React, { useLayoutEffect, useRef } from 'react';
import type { RegistryComponentProps } from '../../../pages/registry/componentRegistry';
import { useDataLayer } from '../hooks/useDataLayer';

export default function StateBoundariesDataLayer(
  props: RegistryComponentProps
): React.ReactElement {
  const { slug, isReady, isActive, setActive, mapController } = useDataLayer(props);
  const syncedFromLayoutRef = useRef(false);

  // When layer is in layout, mapController has it active but our isActive may not have synced yet.
  useLayoutEffect(() => {
    if (syncedFromLayoutRef.current || !setActive || !mapController?.isReady()) return;
    if (mapController.isLayerActive(slug) && !isActive) {
      setActive(true);
      syncedFromLayoutRef.current = true;
    }
  }, [slug, isActive, setActive, mapController]);

  return (
    <div className="control-section">
      <div className="section-title">
        <span className="section-icon">US State Boundaries</span>
      </div>
      <div className="form-group">
        <label
          className="checkbox-label"
          style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        >
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setActive(e.target.checked)}
            disabled={!isReady}
            style={{ marginRight: '8px' }}
          />
          <span>Show US State Boundaries</span>
        </label>
        <div style={{ fontSize: '11px', color: '#6c757d', marginTop: '6px', fontStyle: 'italic' }}>
          Display state boundaries with labels
        </div>
      </div>
    </div>
  );
}
